import { useQuery } from "@tanstack/react-query";
import { MedicationRow } from "../api/medication.type";
import { getMedications } from "../api/medications.api";

function useLoadMedications(userId?: string) {
  const {
    data: medications = [],
    isLoading,
    error,
  } = useQuery<MedicationRow[]>({
    queryKey: ["medications", userId],
    queryFn: () => getMedications(userId),
  });

  return { medications, isLoading, error };
}

export default useLoadMedications;

